import { useClinicAssessmentBalance } from 'lib/hooks/tanstack/use-clinicAssessmentBalance';

export function useBillingPermissions() {
  const baselineBalanceQuery = useClinicAssessmentBalance('baseline');
  const postInjuryBalanceQuery = useClinicAssessmentBalance('post-injury');

  const isLoading =
    baselineBalanceQuery.isLoading || postInjuryBalanceQuery.isLoading;
  const isError =
    baselineBalanceQuery.isError || postInjuryBalanceQuery.isError;

  const baselineData = baselineBalanceQuery.data?.data;
  const postInjuryData = postInjuryBalanceQuery.data?.data;

  const isBothBalancesInfinite =
    baselineData?.isInfinite === true && postInjuryData?.isInfinite === true;

  const isBulkPurchaseEnabled =
    postInjuryData?.supportsBulkPurchases.value === true && baselineData?.supportsBulkPurchases.value === true;

  const shouldShowTopUpButton =
    !isBothBalancesInfinite && isBulkPurchaseEnabled;

  return {
    shouldShowTopUpButton: shouldShowTopUpButton,
    isBothBalancesInfinite: isBothBalancesInfinite,
    isBothBalancesPurchaseDisabled: [
      baselineData?.supportsBulkPurchases.value,
      baselineData?.supportsOnDemandPurchases.value,
      postInjuryData?.supportsBulkPurchases.value,
      postInjuryData?.supportsOnDemandPurchases.value
    ].every(_ => _ === false),
    isLoading: isLoading,
    isError: isError
  };
}
